export default {
  reservations: [
    {
      key: "selected",
      label: "",
      sortable: false,
      class: "text-center",
      thStyle: { minWidth: "30px" },
      stickyColumn: true,
      settings: {
        drag: false,
        disabled: true,
        default: true,
      },
    },
    {
      key: "booking_number",
      label: "Reservation N°/ ID",
      sortable: true,
      thStyle: { minWidth: "170px" },
      class: "text-left",
      stickyColumn: true,
      settings: {
        drag: false,
        disabled: true,
        default: true,
      },
    },
    {
      key: "reservationType",
      label: "Reservation Type",
      sortable: true,
      thStyle: { minWidth: "140px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "typeTransfer",
      label: "Type Transfer",
      sortable: true,
      thStyle: { minWidth: "140px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "from",
      label: "From",
      sortable: true,
      thStyle: { minWidth: "320px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "to",
      label: "To",
      sortable: true,
      thStyle: { minWidth: "320px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "pickup_date",
      label: "Date & Time",
      sortable: true,
      thStyle: { minWidth: "120px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },

    {
      key: "transportRef",
      label: "Transport Ref.",
      sortable: true,
      thStyle: { minWidth: "120px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "customer",
      label: "Customer",
      sortable: true,
      thStyle: { minWidth: "150px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "passenger",
      label: "PAX",
      sortable: true,
      thStyle: { minWidth: "150px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "passengersCount",
      label: "PAX N°",
      sortable: true,
      thStyle: { minWidth: "130px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "destination",
      label: "Destination",
      sortable: true,
      thStyle: { minWidth: "170px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "service",
      label: "Service",
      sortable: true,
      thStyle: { minWidth: "220px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "driver",
      label: "Driver",
      sortable: true,
      thStyle: { minWidth: "120px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "netprice",
      label: "Net Price",
      sortable: true,
      thStyle: { minWidth: "130px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "grossprice",
      label: "Gross Price",
      sortable: true,
      thStyle: { minWidth: "130px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "netprofit",
      label: "Net Profit",
      sortable: true,
      thStyle: { minWidth: "130px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "totalExtras",
      label: "Extra Charges",
      sortable: true,
      thStyle: { minWidth: "170px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "totalDiscounts",
      label: "Discounts",
      sortable: true,
      thStyle: { minWidth: "130px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "totalcharge",
      label: "Total Charge",
      sortable: true,
      thStyle: { minWidth: "130px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "reservation_reference",
      label: "Reserv. Ref.",
      sortable: true,
      thStyle: { minWidth: "160px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "invoice_n",
      label: "Invoice N°",
      sortable: true,
      thStyle: { minWidth: "130px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "status",
      label: "Status",
      sortable: true,
      thStyle: { minWidth: "110px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      class: "alinmov6",
      thStyle: { minWidth: "90px" },
      stickyColumn: false,
      settings: {
        drag: false,
        disabled: true,
        default: true,
      },
    },
  ],
  rates: [
    {
      key: "selected",
      label: "",
      sortable: false,
      class: "text-center",
      thStyle: { minWidth: "40px" },
      stickyColumn: true,
      settings: {
        drag: false,
        disabled: true,
        default: true,
      },
    },
    {
      key: "category",
      label: "Vehicle",
      sortable: true,
      thStyle: { minWidth: "160px" },
      class: "text-left",
      stickyColumn: true,
      settings: {
        drag: false,
        disabled: true,
        default: true,
      },
    },
    {
      key: "destination",
      label: "Destination",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: true,
        default: true,
      },
    },
    {
      key: "pricingSelections",
      label: "Pricing Selections",
      sortable: true,
      thStyle: { minWidth: "120px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "seats",
      label: "N° Seats",
      sortable: true,
      thStyle: { minWidth: "80px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "childSeats",
      label: "N° Child Seats",
      sortable: true,
      thStyle: { minWidth: "80px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "childSeatPrice",
      label: "Child Seat Price",
      sortable: true,
      thStyle: { minWidth: "80px" },
      class: "alinmov7",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "areas",
      label: "Areas",
      sortable: true,
      thStyle: { minWidth: "50px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "especialConditions",
      label: "Especial Cond.",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "minbasePriceByArea",
      label: "Price",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "alinmov7",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "priceByDistance",
      label: "Price Extra KM",
      sortable: true,
      thStyle: { minWidth: "110px" },
      class: "alinmov7",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "validity",
      label: "Validity",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "text-left",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "status",
      label: "Status",
      sortable: true,
      thStyle: { minWidth: "130px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: true,
      },
    },
    {
      key: "basePrice",
      label: "Base Price",
      sortable: true,
      thStyle: { minWidth: "130px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "currency",
      label: "Currency",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "minimumDisposition",
      label: "Hourly Minimum",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
     {
      key: "maximumDisposition",
      label: "Hourly Maximum",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },

    {
      key: "distanceInclude",
      label: "Km inc. x hour",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "priceByDisposition",
      label: "Price x hour",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "alinmov7",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },
    {
      key: "meetAndGreetPrice",
      label: "Meet & Greet Price",
      sortable: true,
      thStyle: { minWidth: "100px" },
      class: "alinmov6",
      settings: {
        drag: true,
        disabled: false,
        default: false,
      },
    },

    {
      key: "actions",
      label: "Actions",
      sortable: false,
      class: "alinmov6",
      thStyle: { minWidth: "90px" },
      stickyColumn: false,
      settings: {
        drag: false,
        disabled: true,
        default: true,
      },
    },
  ],
};
